require('./dist/drawer-dialog/drawer-dialog.css');
